export default "__VITE_ASSET__BTax1GcM__"